import { Expose, Type } from 'class-transformer';

import { Default } from '@lib/common/decorators';

import { SnIntegrationLayer } from '../integration-layer';
import { SnLayerMeta } from '../layer-meta';

export class SnAerisWeatherMeta extends SnLayerMeta {
  @Expose()
  @Default('')
  public apiClientKey: string;

  @Expose()
  @Default('')
  public apiClientId: string;

  @Expose()
  @Default(false)
  public isPremium: boolean;
}

export class SnAerisWeatherLayer extends SnIntegrationLayer {
  @Expose()
  @Default('AerisWeather Integration')
  public name: string;

  @Expose()
  @Default('AerisWeather')
  public integrationType: string;

  @Expose()
  @Type(() => SnAerisWeatherMeta)
  @Default(new SnAerisWeatherMeta())
  public meta: SnAerisWeatherMeta;
}
